import React, { useMemo, useContext } from 'react';
import { useUserRoles } from './role-user-hook';
import {
  Table,
  ApiFilterOperation,
  TableHandle,
  useUpdateEffect,
  useEventCallback,
  DetailContext,
  DetailMode,
} from '@eas/common-web';
import { User, RoleInstance } from '../../../../models';
import { ExportTags } from '../../../../enums/export-tags';
import { ToolbarExportButton } from '../../../../components/evidence/history-evidence/overrides/toolbar-export-button';

export function UserRoles({
  tableName = 'Běžný uživatel subjektu',
  profile,
  useStyles,
  showReportButton = true,
}: {
  tableName?: string;
  profile: User;
  useStyles?: () => TableHandle<RoleInstance>['classes'];
  showReportButton?: boolean;
}) {
  const detailCtx = useContext(DetailContext);
  const { source, columns } = useUserRoles(profile);

  const filters = useMemo(
    () => [
      {
        field: 'role.relationship.id',
        operation: ApiFilterOperation.EQ,
        value: 'USER',
      },
    ],
    []
  );

  const include = useMemo(() => ['DEACTIVATED'], []);

  const sorts = useMemo(
    () => [
      {
        field: 'active',
        datakey: 'active',
        order: 'DESC' as const,
        type: 'FIELD' as const,
      },
      {
        field: 'validFrom',
        datakey: 'validFrom',
        order: 'DESC' as const,
        type: 'FIELD' as const,
      },
    ],
    []
  );

  const exportProvideData = useEventCallback(() => ({
    userId: profile.id,
  }));

  useUpdateEffect(() => {
    if (detailCtx?.mode === DetailMode.VIEW) {
      source.reset();
      source.loadMore();
    }
  }, [profile.id]);

  return (
    <Table
      version={6}
      tableId="ROLES_AS_USER"
      tableName={tableName}
      columns={columns}
      source={source}
      height={300}
      showBulkActionButton={false}
      showSelectBox={false}
      showSearchbar={false}
      showReportButton={false}
      showResetSortsButton={true}
      reportTag={ExportTags.USER_ROLES}
      exportProvideData={exportProvideData}
      defaultPreFilters={filters}
      defaultSorts={sorts}
      include={include}
      useStyles={useStyles}
      toolbarProps={{
        after: detailCtx?.mode === DetailMode.VIEW && showReportButton && (
          <ToolbarExportButton />
        ),
      }}
    />
  );
}
